import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-circle-small-fill-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm2.93 4.886a.75.75 0 0 0-1.044.184l-2.908 4.151-.878-1.171a.75.75 0 0 0-1.2.9l1.5 2a.75.75 0 0 0 1.214-.02l3.5-5a.75.75 0 0 0-.184-1.044Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
